import { render, staticRenderFns } from "./secret-dialog.vue?vue&type=template&id=2c6def5f&scoped=true&"
import script from "./secret-dialog.vue?vue&type=script&lang=js&"
export * from "./secret-dialog.vue?vue&type=script&lang=js&"
import style0 from "./secret-dialog.vue?vue&type=style&index=0&id=2c6def5f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6def5f",
  null
  
)

export default component.exports